// fileHelper.js
// Handles file uploads to Firebase Storage or to Bubble file upload endpoint

// Optional Firebase SDK import if you want to use Firebase uploads
// import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
// import { initializeApp } from "firebase/app";

// const firebaseConfig = {
//   apiKey: "YOUR_FIREBASE_API_KEY",
//   authDomain: "ensure-add-in.firebaseapp.com",
//   projectId: "ensure-add-in",
//   storageBucket: "ensure-add-in.appspot.com",
//   messagingSenderId: "SENDER_ID",
//   appId: "APP_ID"
// };
// const app = initializeApp(firebaseConfig);
// const storage = getStorage(app);

// Import the API key from bubbleClient
const apiKey = "e57b79494a9f1a109d1d96e3ebba1b4e";

export const FileHelper = {
  bucket: "ensure-add-in.appspot.com",

  sanitizeFilename(name) {
    if (!name) return "untitled";
    return name.replace(/[<>:"/\\|?*]+/g, "_").substring(0, 150);
  },

  async uploadMailToBubble(mailBlob, subject = "email", progressCallback = null) {
    console.log("this is blob", mailBlob);
    const sanitizedSubject = this.sanitizeFilename(subject);
    const timestamp = new Date().toISOString().replace(/[-:.TZ]/g, "");
    const fileName = `${sanitizedSubject}_${timestamp}.msg`;

    try {
      // Simple progress updates
      if (progressCallback) {
        progressCallback(10); // Start of upload
      }

      const formData = new FormData();
      formData.append("file", mailBlob, fileName);

      // Simple fetch without progress simulation
      const response = await fetch("https://ensurebroker.servicecenterdanmark.dk/fileupload", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${apiKey}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`Upload failed: ${response.status} ${response.statusText}`);
      }

      let responseBody = await response.text();

      let fileUrl;
      try {
        fileUrl = JSON.parse(responseBody); // same as JsonConvert.DeserializeObject<string>
      } catch {
        fileUrl = responseBody;
      }

      if (!fileUrl.startsWith("https:", StringComparison?.OrdinalIgnoreCase)) {
        fileUrl = "https:" + fileUrl;
      }

      if (progressCallback) {
        progressCallback(50); // Email upload complete
      }

      return fileUrl;
    } catch (err) {
      console.error("Error Occured while uploading mail:", err);
      if (progressCallback) {
        progressCallback(-1); // Error state
      }
      return null;
    }
  },
  async uploadAttachmentToBubble(file, progressCallback = null, currentAttachment = 1, totalAttachments = 1) {
    const sanitizedFileName = this.sanitizeFilename(file.name);
    const timestamp = new Date().toISOString().replace(/[-:.TZ]/g, "");
    const fileName = `${sanitizedFileName}_${timestamp}`;

    try {
      const formData = new FormData();
      formData.append("file", file, fileName);

      // Calculate progress for this attachment
      const baseProgress = 50;
      const attachmentRange = 30;
      const progressPerAttachment = totalAttachments > 0 ? attachmentRange / totalAttachments : 0;
      const currentProgress = baseProgress + (currentAttachment - 1) * progressPerAttachment;
      const nextProgress = baseProgress + currentAttachment * progressPerAttachment;

      // Simple progress update before upload
      if (progressCallback) {
        progressCallback(Math.round(currentProgress));
      }

      // Simple fetch without progress simulation
      const response = await fetch("https://ensurebroker.servicecenterdanmark.dk/fileupload", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${apiKey}`,
        },
        body: formData,
      });

      if (!response.ok) throw new Error(`Upload failed: ${response.statusText}`);
      let fileUrl = await response.text();

      try {
        fileUrl = JSON.parse(fileUrl);
      } catch {
        // skip
      }

      if (!fileUrl.startsWith("https:")) fileUrl = "https:" + fileUrl;

      // Update progress after successful upload
      if (progressCallback) {
        progressCallback(Math.round(nextProgress));
      }

      return fileUrl;
    } catch (err) {
      console.error("Error uploading attachment:", err);
      if (progressCallback) {
        progressCallback(-1); // Error state
      }
      return null;
    }
  },

  
  async uploadMailToFirebase(mailBlob, subject = "email", progressCallback = null) {
    // Initialize Firebase if not already done
    if (!window.firebaseApp) {
      const firebaseConfig = {
        apiKey: "YOUR_FIREBASE_API_KEY",
        authDomain: "ensure-add-in.firebaseapp.com",
        projectId: "ensure-add-in",
        storageBucket: "ensure-add-in.appspot.com",
        messagingSenderId: "SENDER_ID",
        appId: "APP_ID",
      };

      // Check if Firebase is loaded, if not return error
      if (!window.firebase || !window.firebase.initializeApp) {
        console.error("Firebase SDK not loaded. Please include Firebase scripts in your HTML.");
        if (progressCallback) progressCallback(-1);
        return null;
      }

      window.firebaseApp = window.firebase.initializeApp(firebaseConfig);
      window.firebaseStorage = window.firebase.storage();
    }

    const sanitizedSubject = this.sanitizeFilename(subject);
    const timestamp = new Date().toISOString().replace(/[-:.TZ]/g, "");
    const fileName = `${sanitizedSubject}_${timestamp}.msg`;

    try {
      // Simple progress update before upload
      if (progressCallback) {
        progressCallback(10);
      }

      const storageRef = window.firebaseStorage.ref(fileName);
      
      // Create upload task with progress tracking
      const uploadTask = storageRef.put(mailBlob);
      
      // Listen for progress updates
      if (progressCallback && uploadTask.on) {
        uploadTask.on('state_changed', 
          (snapshot) => {
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 40; // Map to 10-50% range
            const totalProgress = 10 + progress;
            progressCallback(Math.round(totalProgress));
          },
          (error) => {
            console.error("Firebase upload error:", error);
            progressCallback(-1);
          },
          () => {
            progressCallback(50); // Upload complete
          }
        );
      }

      const snapshot = await uploadTask;
      const downloadUrl = await snapshot.ref.getDownloadURL();

      if (progressCallback) {
        progressCallback(50); // Ensure final progress
      }

      return downloadUrl;
    } catch (err) {
      console.error("Error uploading mail to Firebase:", err);
      if (progressCallback) {
        progressCallback(-1);
      }
      return null;
    }
  },
  async uploadAttachmentToFirebase(file, progressCallback = null, currentAttachment = 1, totalAttachments = 1) {
    const sanitizedFileName = this.sanitizeFilename(file.name);
    const timestamp = new Date().toISOString().replace(/[-:.TZ]/g, "");
    const fileName = `${sanitizedFileName}_${timestamp}`;

    try {
      // Calculate progress for this attachment
      const baseProgress = 50;
      const attachmentRange = 30;
      const progressPerAttachment = totalAttachments > 0 ? attachmentRange / totalAttachments : 0;
      const currentProgress = baseProgress + (currentAttachment - 1) * progressPerAttachment;

      // Simple progress update before upload
      if (progressCallback) {
        progressCallback(Math.round(currentProgress));
      }

      // Initialize Firebase if not already done
      if (!window.firebaseApp) {
        const firebaseConfig = {
          apiKey: "YOUR_FIREBASE_API_KEY",
          authDomain: "ensure-add-in.firebaseapp.com",
          projectId: "ensure-add-in",
          storageBucket: "ensure-add-in.appspot.com",
          messagingSenderId: "SENDER_ID",
          appId: "APP_ID",
        };

        if (!window.firebase || !window.firebase.initializeApp) {
          console.error("Firebase SDK not loaded. Please include Firebase scripts in your HTML.");
          if (progressCallback) progressCallback(-1);
          return null;
        }

        window.firebaseApp = window.firebase.initializeApp(firebaseConfig);
        window.firebaseStorage = window.firebase.storage();
      }

      const storageRef = window.firebaseStorage.ref(fileName);
      
      // Create upload task with progress tracking
      const uploadTask = storageRef.put(file);
      
      // Listen for progress updates
      if (progressCallback && uploadTask.on) {
        uploadTask.on('state_changed', 
          (snapshot) => {
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * progressPerAttachment;
            const totalProgress = currentProgress + progress;
            progressCallback(Math.round(totalProgress));
          },
          (error) => {
            console.error("Firebase attachment upload error:", error);
            progressCallback(-1);
          }
        );
      }

      const snapshot = await uploadTask;
      const downloadUrl = await snapshot.ref.getDownloadURL();

      return downloadUrl;
    } catch (err) {
      console.error("Error uploading attachment to Firebase:", err);
      if (progressCallback) {
        progressCallback(-1);
      }
      return null;
    }
  },

  showMessage(message, type = "info") {
    const container = document.getElementById("messageContainer");
    if (!container) return;

    container.textContent = message;
    container.className = `message ${type}`;
    container.style.display = "block";

    setTimeout(() => {
      container.style.display = "none";
    }, 3000);
  },
};
